import { cn } from '@/lib/utils'

/** Full-width hairline that fades at the edges — use between major page bands. */
export function SectionSeparator({ className }: { className?: string }) {
  return (
    <div
      role="presentation"
      aria-hidden
      className={cn(
        'pointer-events-none h-px w-full bg-gradient-to-r from-transparent via-hairline to-transparent opacity-80',
        className
      )}
    />
  )
}
